import { MessageCircle } from "lucide-react";

/**
 * OpinionBubbleIcon — 1:1 port of iOS `src/components/OpinionBubble.tsx`.
 *
 * A lucide `MessageCircle` outline with the "+" and "−" glyphs nudged up
 * inside the bubble (so they clear the bubble tail).  Matches the lucide
 * icon prop signature so it can be dropped in anywhere.  Used both as the
 * Opinions tab-bar icon and as the Different-View comment button on
 * opinion cards.
 */
export function OpinionBubbleIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 1.8,
  className = "",
  style,
  testId,
}) {
  const glyphFontSize = size * 0.36;
  const glyphGap = size * 0.08;
  const topOffset = size * 0.22;

  return (
    <span
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size, color, ...style }}
      aria-hidden="true"
      data-testid={testId}
    >
      <MessageCircle size={size} strokeWidth={strokeWidth} color="currentColor" />
      <span
        className="pointer-events-none absolute flex flex-row items-center"
        style={{ top: topOffset, gap: glyphGap, color: "currentColor" }}
      >
        <span
          style={{
            fontSize: glyphFontSize,
            lineHeight: `${size * 0.42}px`,
            fontWeight: 800,
          }}
        >
          +
        </span>
        <span
          style={{
            fontSize: glyphFontSize,
            lineHeight: `${size * 0.42}px`,
            fontWeight: 800,
          }}
        >
          −
        </span>
      </span>
    </span>
  );
}

export default OpinionBubbleIcon;
